/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import type { FC } from 'react';

import ContactLinks from './contact-links';
import { useAvatarImage } from './hooks/use-avatar-image';
import { rhythm } from './styles/typography';

const Contact: FC = () => {
  const image = useAvatarImage();

  return (
    <section>
      <h2>Contact</h2>

      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: ${rhythm(2)} 0 0;

          @media screen and (min-width: 60em) {
            & {
              justify-content: space-between;
              flex-direction: row;
            }
          }
        `}
      >
        <picture
          css={css`
            margin-bottom: ${rhythm(1)};

            @media screen and (min-width: 60em) {
              margin: 0;
            }
          `}
        >
          <source srcSet="" draggable="false" type="image/webp" />
          <GatsbyImage
            css={css`
              border-radius: 50%;
              display: block;
              pointer-events: none;
              user-select: none;
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
              width: ${rhythm(6)};
              flex: 0.1;
            `}
            image={image}
            alt="rmjordas avatar"
          />
        </picture>

        <div
          css={css`
            justify-content: space-between;
            flex: 0.9;

            p {
              margin-bottom: ${rhythm(0.6)};
            }
          `}
        >
          <p>
            <strong>Hello there.</strong>
          </p>

          <p>
            You can e-mail me at rmjordas at gmail dot com or check out my GitHub profile where I
            host my projects.
          </p>

          <ContactLinks />
        </div>
      </div>
    </section>
  );
};

export default Contact;
